export const GROUP = {
  USER: 'user',
  SYSTEM: 'system',
};

export const STATUS = {
  ACTIVE: 'active',
  ERROR: 'error',
  OFF: 'inActive',
  PAUSE: 'pause',
  DRAFT: 'draft',
  PENDING: 'pending',
  ARCHIVED: 'archived',
  DELETED: 'deleted',
};

export const TYPE = {
  DBM: 'DBM',
  DCM: 'DCM',
  CMDV: 'CMDV',
  GOOGLE_ADS: 'googleAds',
  ADWORDS: 'adwords',
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  PINTEREST: 'pinterest',
  TIKTOK: 'tikTok',
};

export const AVAILABLE_TYPES = [
  TYPE.CMDV,
  TYPE.GOOGLE_ADS,
  TYPE.FACEBOOK,
  TYPE.TIKTOK,
];

export const NAMES = {
  [TYPE.CMDV]: 'CM360 & DV360',
  [TYPE.DBM]: 'Display Video 360',
  [TYPE.DCM]: 'Campaign Manager 360',
  [TYPE.GOOGLE_ADS]: 'Google Ads',
  [TYPE.ADWORDS]: 'Google Ads',
  [TYPE.FACEBOOK]: 'Facebook Ads Manager',
  [TYPE.TWITTER]: 'Twitter',
  [TYPE.PINTEREST]: 'Pinterest',
  [TYPE.TIKTOK]: 'Tiktok',
};

export const TYPE_FIELDS = {
  [TYPE.DCM]: [
    { name: 'config._t',
      type: 'hidden',
      value: 'pw.ohm.smalldata.model.adsaccount.DCMAccountConfig' },
    { name: 'config.token',
      label: 'Token',
      pattern: '^[a-f0-9]{32}$' },
    { name: 'config.advertiserId',
      label: 'Advertiser ID',
      required: true },
  ],
  [TYPE.DBM]: [
    { name: 'config._t',
      type: 'hidden',
      value: 'pw.ohm.smalldata.model.adsaccount.DBMUserAccountConfig' },
    { name: 'config.token',
      label: 'Token',
      pattern: '^[a-f0-9]{32}$' },
    { name: 'config.advertiserId',
      label: 'Advertiser ID',
      required: true },
    { name: 'config.src',
      label: 'src' },
  ],
  [TYPE.CMDV]: [
    { name: 'config._t',
      type: 'hidden',
      value: 'pw.ohm.smalldata.model.adsaccount.CMDVAccountConfig' },
    { type: 'Long',
      enableForSystem: true,
      name: 'config.profileId',
      label: 'Profile ID' },
    { name: 'config.token',
      label: 'Token',
      pattern: '^[a-f0-9]{32}$' },
    { name: 'config.advertiserId',
      label: 'Advertiser ID',
      type: 'Long',
      required: true },
    { name: 'config.dvAdvertiserId',
      label: 'dvAdvertiserId',
      type: 'Long' },
    { name: 'config.siteId',
      label: 'siteId',
      type: 'Long' },
  ],
  [TYPE.GOOGLE_ADS]: [
    { name: 'config._t',
      type: 'hidden',
      value: 'pw.ohm.smalldata.model.adsaccount.AdwordsSharedConfig' },
    // { name: 'config.serviceKeyName',
    //   label: 'serviceKeyName',
    //   required: true },
    { name: 'config.accountId',
      label: 'accountId',
      required: true },
    { name: 'config.linkId',
      label: 'linkId',
      required: true },
  ],
  [TYPE.FACEBOOK]: [
    { name: 'config._t',
      type: 'hidden',
      value: 'pw.ohm.smalldata.model.adsaccount.FacebookAdsAuditorySharedConfig' },
    { name: 'config.accessToken',
      label: 'accessToken',
      required: true },
    { name: 'config.accountId',
      label: 'accountId',
      required: true },
    { name: 'config.clientId',
      label: 'clientId',
      required: true },
    { name: 'config.userId',
      label: 'userId',
      required: true },
    { name: 'config.customAudienceTos',
      label: 'customAudienceTos',
      type: 'Integer' },
  ],
  [TYPE.TIKTOK]: [
    { name: 'config._t',
      type: 'hidden',
      value: 'pw.ohm.smalldata.model.adsaccount.TikTokSharedConfig' },
    { name: 'config.token',
      label: 'Token',
      required: true },
    { name: 'config.advertiserId',
      type: 'Long',
      label: 'Advertiser ID',
      required: true },
  ],
};

export const TYPE_INSTANCE_FIELDS = {
  [TYPE.CMDV]: [
    { name: 'config._t',
      type: 'hidden',
      value: 'pw.ohm.smalldata.model.adsaccount.CMDVAccountInstanceConfig' },
    { name: 'config.cat',
      label: 'Cat',
      required: true,
      pattern: '^[a-zA-Z0-9_\\.-]*' },
    { name: 'config.type',
      label: 'Type' },
    { type: 'Long',
      name: 'config.floodlightId',
      label: 'Floodlight ID' },
    { name: 'config.floodlightName',
      label: 'Floodlight Name' },
    { type: 'Long',
      name: 'config.floodlightActivityGroupID',
      label: 'Floodlight Activity Group ID' },
    { type: 'Long',
      name: 'config.floodlightConfigurationId',
      label: 'Floodlight Configuration ID' },
    { type: 'Long',
      name: 'config.remarketingListId',
      label: 'Remarketing List ID' },
  ],

  [TYPE.GOOGLE_ADS]: [
    { name: 'config._t',
      type: 'hidden',
      value: 'pw.ohm.smalldata.model.adsaccount.AdwordsLocalConfig' },
    { name: 'config.auditoryIdOrName',
      type: 'hidden',
      label: 'Auditory ID or Name',
      required: true },
  ],

  [TYPE.TIKTOK]: [
    { name: 'config._t',
      type: 'hidden',
      value: 'pw.ohm.smalldata.model.adsaccount.TikTokLocalConfig' },
    { name: 'config.auditoryIdOrName',
      type: 'hidden',
      label: 'Auditory ID or Name' },
    { name: 'config.conversionEventName',
      label: 'Conversion Event Name' },
  ],

  [TYPE.FACEBOOK]: [
    { name: 'config._t',
      type: 'hidden',
      value: 'pw.ohm.smalldata.model.adsaccount.FacebookAdsAuditoryLocalConfig' },
    { name: 'config.auditoryIdOrName',
      type: 'hidden',
      label: 'Auditory ID or Name',
      required: true },
  ],
};

export const INSTANCE_SYSTEM_BY_DEFAULT = {
  [TYPE.CMDV]: true,
};
